import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import './ContactPage.css';

const NAP = {
  name: 'Enzlo Digitalagentur',
  street: 'Eckweg 8',
  postal: '64354',
  city: 'Reinheim',
  phone: '+49 157 516 19973',
  email: 'hi@enzlo.com',
  url: 'https://enzlo.com/kontakt',
};

const ContactPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
      <title>{t('contactMetaTitle')}</title>
      <meta name="description" content={t('contactMetaDescription')} />
      <link rel="canonical" href="https://enzlo.com/contakt" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://enzlo.com/contakt" />
      <meta property="og:title" content={t('contactMetaTitle')} />
      <meta property="og:description" content={t('contactMetaDescription')} />
      <meta property="og:image" content="https://enzlo.com/logo.png" />
      <meta property="og:site_name" content="Enzlo" />
      <meta property="og:see_also" content="https://www.facebook.com/enzloinc/" />
      <meta property="og:see_also" content="https://www.youtube.com/@Totalemailautoresponder" />
      <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "Kontakt – Spoddig UG (haftungsbeschränkt)",
          "url": "https://enzlo.com/contakt",
          "mainEntity": {
            "@type": "LocalBusiness",
            "name": "Spoddig UG (haftungsbeschränkt)",
            "legalName": "Spoddig UG (haftungsbeschränkt), HRB 234397 B",
            "logo": "https://enzlo.com/assets/logo.png",
            "telephone": "+4915751619973",
            "email": "hi@enzlo.com",
            "sameAs": [
              "https://www.facebook.com/enzloinc/",
              "https://www.youtube.com/@Totalemailautoresponder"
            ],
            "address": [
              {
                "@type": "PostalAddress",
                "streetAddress": "Eckweg 8",
                "postalCode": "64354",
                "addressLocality": "Reinheim",
                "addressCountry": "DE"
              },
              {
                "@type": "PostalAddress",
                "streetAddress": "Zeppelinstraße 20",
                "postalCode": "73084",
                "addressLocality": "Salach",
                "addressCountry": "DE"
              }
            ],
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "+4915751619973",
                "contactType": "customer service",
                "email": "hi@enzlo.com",
                "areaServed": ["Frankfurt", "Darmstadt", "Stuttgart", "Ulm", "Aschaffenburg"]
              }
            ]
          }
        }
      `}</script>
    </Helmet>
    <main className="contact-page">
      <div className="contact-container">
        <div className="contact-grid">
          <div className="contact-info">
            <h1>Kontakt aufnehmen</h1>
            <p className="subtitle">
              Bereit, Ihr Projekt auf das nächste Level zu heben? Wir freuen uns darauf, von Ihnen zu hören. Füllen Sie das Formular aus oder erreichen Sie uns direkt.
            </p>
            <div className="contact-details">
              <h3>Direkter Kontakt</h3>
              <p><a href={`mailto:${NAP.email}`}>{NAP.email}</a></p>
              <p><a href={`tel:${NAP.phone.replace(/\s+/g, '')}`}>{NAP.phone}</a></p>
              <p>
                {NAP.street}<br />
                {NAP.postal} {NAP.city}
              </p>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h2>Schreiben Sie uns</h2>
            <form name="contact" method="POST" data-netlify="true" netlify-honeypot="bot-field">
              <input type="hidden" name="form-name" value="contact" />
              <p style={{ display: 'none' }}>
                <label>Don’t fill this out if you’re human: <input name="bot-field" /></label>
              </p>

              <div className="form-group">
                <input type="text" id="name" name="name" className="form-input" placeholder=" " required />
                <label htmlFor="name" className="form-label">Name*</label>
              </div>

              <div className="form-group">
                <input type="email" id="email" name="email" className="form-input" placeholder=" " required />
                <label htmlFor="email" className="form-label">E-Mail*</label>
              </div>

              <div className="form-group">
                <textarea id="message" name="message" className="form-input" placeholder=" " required></textarea>
                <label htmlFor="message" className="form-label">Ihre Nachricht*</label>
              </div>

              <button type="submit" className="submit-button">Anfrage senden</button>
            </form>
          </div>
        </div>
      </div>
    </main>
  </>
  );
};

export default ContactPage;
